// @flow
import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  ListGroup,
  ListGroupItem,
} from "react-bootstrap";
import WizardForm from "./form/WizardForm";
import logo from "./wgso.png";
import "./styles.css";

type Props = {
  onSelect: Function,
  activeKey: string,
  handleSubmit: Function
};

type State = {
  outboundForm: boolean
};

class TravelDetailsPanel extends Component<Props, State> {
  props: Props;
  state: State;

  constructor(props: Props) {
    super(props);
    this.state = {
      outboundForm: true
    };
  }

  handleSubmit = () => {
    this.setState({ outboundForm: !this.state.outboundForm }, () => {
      let transferDetails = "transferDetailsOutboundForm";
      let page = 1
      if (!this.state.outboundForm) {
        transferDetails = "transferDetailsInboundForm";
        page=2
      }
if(this.props.activeKey !== "3"){
  window.history.replaceState(
    null,
    "Airport Transfers to Ski Resorts | Ski-Lifts",
    "/quote/" + this.props.qID + "/stp2/" + transferDetails + "/"+page
  );
}
    });
  };

  render() {
    if (!this.props.transfers)
      return (
        <div className="text-center">
          <h1 style={{ color: "red" }}>Server Error</h1>
        </div>
      );
    let idValue= "";

       if(this.state.outboundForm ){
         idValue = this.props.transfers[0].id;
       }else if(this.props.transfers[1]){
         idValue =this.props.transfers[1].id;
       }else{
         idValue = this.props.transfers[0].id
       }
    return (
      <Grid className="travel-details-panel">
        <Row>
          <Col xs={12} sm={5} className="form-wrapper">
            {this.state.outboundForm ? (
              <WizardForm
                form={"transferDetailsOutboundForm"}
                isThereAnInboundForm={Boolean(
                  this.props.transfers && this.props.transfers[1]
                )}
                onSelect={this.props.onSelect}
                onSubmit={this.handleSubmit}
                activeKey={this.props.activeKey}
                transfers={this.props.transfers && this.props.transfers[0]}
                idValue={idValue}
                basketId={this.props.basketId}
                qID={this.props.qID}
                help={this.props.info.help}
                initialValues={this.props.initialOutboundValues}
                seatTypes={this.props.info.seatTypes}
                childAges={this.props.info.childAges}
              />
            ) : (
              <WizardForm
                form={"transferDetailsInboundForm"}
                isThereAnInboundForm={Boolean(
                  this.props.transfers && this.props.transfers[1]
                )}
                onSelect={this.props.onSelect}
                onSubmit={this.handleSubmit}
                activeKey={this.props.activeKey}
                transfers={this.props.transfers && this.props.transfers[1]}
                idValue={idValue}
                basketId={this.props.basketId}
                qID={this.props.qID}
                help={this.props.info.help}
                initialValues={this.props.initialInboundValues}
                seatTypes={this.props.info.seatTypes}
                childAges={this.props.info.childAges}
              />
            )}
          </Col>
          <Col xs={0} sm={7} xsHidden className="section-one">
            <Row className="list">
              <ListGroup>
                <ListGroupItem>
                  <h4>
                    <br/>
                  ✓ <strong>Trusted</strong> by over 1 million passengers over the past 15 years
                  </h4>
                </ListGroupItem>
                <ListGroupItem>
                  <h4>
                  ✓ <strong>4 Time Winner of Best Ski Transfer Operator</strong> at the World Ski Awards – 15, 16, 17, 19
                  </h4>
                </ListGroupItem>
                <ListGroupItem>
                  <h4>
                  ✓ <strong>Book with confidence</strong> - secure payment powered by Paypal
                  </h4>
                </ListGroupItem>
                <ListGroupItem>
                  <h4>
                  ✓ <strong>Flexible booking</strong> - 100% free cancellation 7 days prior to travel.  Plus our Covid guarantee
                  </h4>
                </ListGroupItem>
                <ListGroupItem>
                  <h4>
                  ✓ <strong>No hidden fees</strong> – Skis, child seats, luggage and amendments are all included
                  </h4>
                </ListGroupItem>
                <ListGroupItem>
                  <h4>
                  ✓ <strong>24 hour assistance</strong> – in case you’re delayed or need our help
                  </h4>
                </ListGroupItem>
              </ListGroup>
            </Row>
            <Row className="image">
              <img src={logo} alt="Logo" />;
            </Row>
          </Col>
          <Col xs={0} smHidden xsHidden className="text-right section-two">
            <img src={logo} alt="Logo" />;
          </Col>
        </Row>
      </Grid>
    );
  }
}

export default TravelDetailsPanel;



// WEBPACK FOOTER //
// ./src/containers/QuotePage/TravelDetailsPanel/index.js